import React, {Component} from 'react'
import Proptype from 'prop-types'
import 'react-hint/css/index.css'
import './style.css'

import ReactHintFactory from 'react-hint'
const ReactHint = ReactHintFactory(React)

const  NRTTooltip = ({position = 'top' , ...props }) =>  {



        return <div>
            <ReactHint autoPosition events delay={100} />
            <ReactHint persist
                       attribute="data-custom"
                       className="custom-hint"
                       events={{click: true}}
                       autoPosition
            />

            <span data-rh={props.text}
                  data-rh-at={position}>
                {props.children}
            </span>
        </div>

}

NRTTooltip.propTypes = {
    text : Proptype.string.isRequired ,
}

export default NRTTooltip



// WEBPACK FOOTER //
// ./src/components/_common/Tooltip/index.js